import React from 'react';
import { useBodyClass } from '../hooks/useBodyClass';

type AuthLayoutVariant = 'login' | 'register' | 'verify';

type AuthLayoutProps = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  variant?: AuthLayoutVariant;
};

const VARIANT_CONFIG: Record<
  AuthLayoutVariant,
  { body: string[]; container: string; cardBodyClass: string; messageClass: string }
> = {
  login: {
    body: ['hold-transition', 'login-page', 'bg-body-secondary'],
    container: 'login-box',
    cardBodyClass: 'login-card-body',
    messageClass: 'login-box-msg',
  },
  register: {
    body: ['hold-transition', 'register-page', 'bg-body-secondary'],
    container: 'register-box',
    cardBodyClass: 'register-card-body',
    messageClass: 'register-box-msg',
  },
  verify: {
    body: ['hold-transition', 'login-page', 'verify-page', 'bg-body-secondary'],
    container: 'login-box',
    cardBodyClass: 'login-card-body',
    messageClass: 'login-box-msg',
  },
};

export function AuthLayout({ title, subtitle, children, variant = 'login' }: AuthLayoutProps) {
  const config = VARIANT_CONFIG[variant] ?? VARIANT_CONFIG.login;
  useBodyClass(config.body);

  return (
    <div className={`${config.container} py-4`}>
      <div className="card card-outline card-primary shadow-sm">
        <div className="card-header text-center border-0 pt-4">
          <h1 className="h2 mb-0 text-primary">
            <strong>{title}</strong>
          </h1>
        </div>
        <div className={`card-body ${config.cardBodyClass}`}>
          {subtitle ? <p className={`${config.messageClass} text-muted`}>{subtitle}</p> : null}
          {children}
        </div>
      </div>
    </div>
  );
}
